var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoVaultsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 5.25087H12.5625C14.1425 5.25087 14.9326 5.25087 15.5 5.63017C15.7457 5.79438 15.9567 6.00538 16.1208 6.25113C16.4847 6.79588 16.4994 7.5456 16.5 9.00195V9.75218M9 5.25087L8.52495 4.30044C8.13135 3.51305 7.77165 2.72048 6.89945 2.3933C6.51743 2.25 6.08102 2.25 5.20821 2.25C3.84585 2.25 3.16468 2.25 2.65355 2.53532C2.2892 2.73871 1.98857 3.03943 1.78524 3.40388C1.5 3.91516 1.5 4.59653 1.5 5.95928V8.25173C1.5 11.7883 1.5 13.5566 2.59835 14.6552C3.52897 15.5861 4.94016 15.7283 7.5 15.75M14.25 13.875L15.334 14.5976C15.8473 14.9398 16.1039 15.1109 16.3019 15.0049C16.5 14.899 16.5 14.5905 16.5 13.9736V13.0264C16.5 12.4095 16.5 12.101 16.3019 11.995C16.1039 11.8891 15.8473 12.0602 15.334 12.4024L14.25 13.125M14.25 13.875V13.125M14.25 13.875C14.25 14.5759 14.25 14.9264 14.0992 15.1875C14.0005 15.3585 13.8585 15.5005 13.6875 15.5992C13.4264 15.75 13.0759 15.75 12.375 15.75H12C10.9394 15.75 10.409 15.75 10.0795 15.4205C9.75 15.091 9.75 14.5606 9.75 13.5C9.75 12.4394 9.75 11.909 10.0795 11.5795C10.409 11.25 10.9394 11.25 12 11.25H12.375C13.0759 11.25 13.4264 11.25 13.6875 11.4008C13.8585 11.4995 14.0005 11.6415 14.0992 11.8125C14.25 12.0736 14.25 12.4241 14.25 13.125",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoVaultsIcon);
export default __webpack_public_path__ + "static/media/video-vaults-icon.0f1a491b79df7d471a330b34e5444e28.svg";
export { ForwardRef as ReactComponent };